import MediatorManager from "../../../core/application/MediatorManager";
import SkinFactory from "../../../core/ui/SkinFactory";
import NPCModel from "../../scenario/NPCModel";
import ChatModel from "../model/ChatModel";
import ChatContactItemMediator from "../view/ChatContactItemMediator";

export default class ChatContactItemFactory {
    /**
     * @constructor
     * @param {MediatorManager} mediatorManager 
     * @param {NPCModel} npcModel 
     * @param {ChatModel} chatModel 
     */
    constructor(mediatorManager, npcModel, chatModel) {
        this._mediatorManager = mediatorManager;
        this._npcModel = npcModel;
        this._chatModel = chatModel;
    }

    /**
     * Creates a chat contact item from the given npc id
     * @param {string} npcId 
     * @param {Object} skinKeyRegistry The skin key registry to instantiate the item skin from (e.g. SmartphoneSkinKeyRegistry)
     * @returns {ChatContactItemMediator}
     */
    createItem(npcId, skinKeyRegistry) {
        const skin = SkinFactory.getSkin(skinKeyRegistry.CHAT_CONTACT_ITEM_SKIN);

        /** @type {NPCContent} */
        const npc = this._npcModel.getNpcByNpcID(npcId);
        const conversation = this._chatModel.getConversationForNpcId(npcId);

        skin.customData = {
            npcId,
            npc,
            conversation
        };

        return this._mediatorManager.createMediator(skin, skinKeyRegistry.CHAT_CONTACT_ITEM_SKIN);
    }
}